import type { ClinicSession } from "@auth/clinicAuthClient";
import type { ClinicUser } from "@users/userClient";
import { createContext, useContext } from "react";

export interface UserContextValue {
  /** User-scope session, or null before the access code is verified. */
  session: ClinicSession | null;
  /** The signed-in user (from GET /auth/user), or null. */
  currentUser: ClinicUser | null;
  isUserAuthed: boolean;
  /** Verify a 2-digit user code + PIN; sets the user session on success. */
  submitAccessCode: (code: string, pin: string) => Promise<void>;
  /** Drop the user session, returning to the access-code screen. */
  switchUser: () => void;
}

export const UserContext = createContext<UserContextValue | null>(null);

export const useUser = () => {
  const ctx = useContext(UserContext);
  if (!ctx) throw new Error("useUser must be used within UserProvider");
  return ctx;
};
